<template>
  <div class="custom-progress-wrapper">
    <el-progress
        :percentage="percentage" :show-text="false" :stroke-width="8"
    />
    <div class="percentage">
      {{percentage}}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomProgress',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss">
.custom-progress-wrapper {
  height: 12px;
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  display: flex;
  position: relative;

  & > div {
    flex: 1;
    margin: auto;
  }
  .el-progress-bar__outer {
    background-color:transparent;
  }
  .percentage {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 12px;
    font-size: 12px;
  }
}
</style>